<template>
  <v-list-item three-line>
    <v-skeleton-loader type="list-item-two-line" v-if="isLoading || (group && group.loading)" />
    <v-list-item-content v-else-if="group">
      <v-list-item-title class="text-truncate">
        <div style="display: flex">
          <div>
            <a v-if="hasOpenDetailListener()" @click.stop="emitOpenDetail">
              {{ group.title }}
            </a>
            <span v-else>
              {{ group.title }}
            </span>
          </div>
          <v-spacer />
        </div>
      </v-list-item-title>
      <v-list-item-subtitle v-if="group.description" class="text-truncate text-xs">
        {{ group.description }}
      </v-list-item-subtitle>
    </v-list-item-content>
    <latest-entries-card-empty v-else />
  </v-list-item>
</template>

<script lang="ts">
import LatestEntriesCardEmpty from "@/components/cards/LatestEntriesCardEmpty.vue";
import { ILeadGroup } from "@/models/lead-group.entity";
import { mixins } from "vue-class-component";
import { Component, Prop, Vue } from "vue-property-decorator";
import { IRefDetail } from "./RefsList.vue";

@Component({
  components: { LatestEntriesCardEmpty },
  filters: {}
})
export default class RefsLeadGroup extends mixins(Vue) implements IRefDetail<ILeadGroup> {
  @Prop()
  item!: ILeadGroup;

  @Prop()
  itemAsync?: Promise<ILeadGroup>;

  @Prop()
  small!: boolean;

  @Prop()
  confirmable!: boolean;

  isLoading = false;

  group: ILeadGroup | null = null;

  hasClickListener() {
    return Boolean(this.$listeners && this.$listeners.click);
  }

  hasOpenDetailListener() {
    return Boolean(this.$listeners && this.$listeners.openDetail);
  }

  emitOpenDetail() {
    this.$emit("openDetail", this.group || this.item);
  }

  async beforeMount() {
    this.isLoading = true;

    if (this.item) {
      this.group = this.item;
    } else if (this.itemAsync) {
      try {
        this.group = await this.itemAsync;
      } catch (e) {
        this.$log.error(e);
      }
    }

    this.isLoading = false;
  }

  async goToDetail() {
    const leadGroup = this.group || this.item;
    if (!leadGroup) return;

    const route = this.$router.resolve({
      name: "LEAD_GROUP_DETAIL",
      params: {
        partnerId: leadGroup.partnerId,
        leadGroupId: leadGroup.id
      }
    });

    window.open(route.href, "_blank");
  }
}
</script>
